// TOC builder: headings h1-h4 inside the article body.
// Level rule: h1 and h2 -> top level, h3 -> 2nd level, h4 -> 3rd level.
// The same generated list is cloned into the desktop (sticky) and mobile (<details>) containers.
document.addEventListener('DOMContentLoaded', () => {
  const prose = document.querySelector('.p-prose');
  const desktop = document.querySelector('[data-toc]');
  const mobile = document.querySelector('[data-toc-mobile]');
  if (!prose || (!desktop && !mobile)) return;

  const headings = [...prose.querySelectorAll('h1, h2, h3, h4')];
  if (!headings.length) return;

  const depthOf = (tag) => ({ H1: 0, H2: 0, H3: 1, H4: 2 })[tag];

  // Build the nested list. A heading never nests deeper than one level below the previous heading
  // (h4 right after h2 becomes 2nd level). If there is no <li> to nest into yet (the list starts
  // with a deeper heading), the heading stays at the current depth, so there are no orphan levels.
  const root = document.createElement('ol');
  // Each heading goes under the nearest preceding heading of a shallower level.
  // A parent gets at most one child list, so levels can never be skipped (h4 right
  // after h2 becomes 2nd level), and an article may start at any level.
  const ancestors = []; // { level, li }

  headings.forEach((h) => {
    if (!h.id) {
      // headings written as raw HTML have no id; make one that doesn't collide with existing ids
      const base = h.textContent.trim().toLowerCase().replace(/\s+/g, '-') || 'section';
      let id = base;
      for (let n = 2; document.getElementById(id); n++) id = `${base}-${n}`;
      h.id = id;
    }
    const level = depthOf(h.tagName);
    while (ancestors.length && ancestors[ancestors.length - 1].level >= level) ancestors.pop();

    const li = document.createElement('li');
    li.className = `toc-${h.tagName.toLowerCase()}`;
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent.trim();
    li.appendChild(a);

    const parent = ancestors[ancestors.length - 1];
    if (!parent) {
      root.appendChild(li);
    } else {
      let list = parent.li.querySelector(':scope > ol');
      if (!list) {
        list = document.createElement('ol');
        parent.li.appendChild(list);
      }
      list.appendChild(li);
    }
    ancestors.push({ level, li });
  });

  [desktop, mobile].forEach((container) => {
    if (!container) return;
    const slot = container.querySelector('[data-toc-list]');
    if (!slot) return;
    slot.replaceWith(root.cloneNode(true));
    container.hidden = false;
  });

  // Scrollspy: mark the current link (in both lists) with aria-current="true" and update
  // the "Section NN of MM" label. Only headings that appear in the TOC count, so a heading
  // without a TOC entry keeps its parent marked.
  const links = [...document.querySelectorAll('[data-toc] a, [data-toc-mobile] a')];
  // markdown-it-anchor ids are percent-encoded strings as they are: compare the raw fragment, never decode
  const fragment = (a) => (a.getAttribute('href') || '').slice(1);
  const listed = new Set(links.map(fragment));
  const spied = headings.filter((h) => listed.has(h.id));
  if (!spied.length) return;
  const tops = spied.filter((h) => depthOf(h.tagName) === 0); // top-level sections

  let progress = null;
  if (desktop && tops.length) {
    progress = document.createElement('p');
    progress.className = 'p-toc__progress p-label';
    progress.setAttribute('aria-hidden', 'true');
    desktop.appendChild(progress);
  }

  // Measure everything first, then write to the DOM only when the active heading or section changes.
  let activeId = null;
  let sectionNo = 0;
  const update = () => {
    const line = innerHeight * 0.3;
    const rects = spied.map((h) => h.getBoundingClientRect().top);
    let active = spied[0];
    spied.forEach((h, i) => { if (rects[i] < line) active = h; });
    const n = tops.filter((h) => rects[spied.indexOf(h)] < line).length || 1;
    if (active.id !== activeId) {
      activeId = active.id;
      links.forEach((a) => {
        if (fragment(a) === activeId) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
    if (progress && n !== sectionNo) {
      sectionNo = n;
      progress.textContent = `Section ${String(n).padStart(2, '0')} of ${String(tops.length).padStart(2, '0')}`;
    }
  };
  let queued = false;
  addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { update(); queued = false; });
  }, { passive: true });
  addEventListener('resize', update);
  update();
});
